import {
  AUTOJOIN_BANNER_DISMISSED,
  AUTOJOIN_DISMISSAL_TIME,
  AUTOJOIN_TOOLTIP_DISMISSED,
  JOIN_SUGGESTED_WORKSPACE_BANNER_DISMISSED,
  JOIN_SUGGESTED_WORKSPACE_DISMISSAL_TIME,
  JOIN_SUGGESTED_WORKSPACE_TOOLTIP_DISMISSED,
  JOIN_SUGGESTED_WORKSPACE_WORKSPACE_SWITCHER_DISMISSED,
  SEEN_SUGGESTED_WORKSPACE_WORKSPACE_SWITCHER,
} from 'constants/localStorage';

import { useStoredStateForUser } from './utils';

export const useAutojoinTooltipState = () => {
  return useStoredStateForUser(AUTOJOIN_TOOLTIP_DISMISSED);
};

export const useAutojoinBannerState = () => {
  return useStoredStateForUser(AUTOJOIN_BANNER_DISMISSED);
};

export const useSuggestedWorkspaceTooltipState = () => {
  return useStoredStateForUser(JOIN_SUGGESTED_WORKSPACE_TOOLTIP_DISMISSED);
};

export const useSuggestedWorkspaceBannerState = () => {
  return useStoredStateForUser(JOIN_SUGGESTED_WORKSPACE_BANNER_DISMISSED);
};

export const useSuggestedWorkspaceTimedDismissalState = () => {
  return useStoredStateForUser(JOIN_SUGGESTED_WORKSPACE_DISMISSAL_TIME);
};

export const useAutojoinTimedDismissalState = () => {
  return useStoredStateForUser(AUTOJOIN_DISMISSAL_TIME);
};

export const useSuggestedWorkspaceWorkspaceSwitcherDismissalState = () => {
  return useStoredStateForUser(
    JOIN_SUGGESTED_WORKSPACE_WORKSPACE_SWITCHER_DISMISSED
  );
};
export const useSeenNewSuggestedWorkspaceWorkspaceSwitcher = () => {
  return useStoredStateForUser(SEEN_SUGGESTED_WORKSPACE_WORKSPACE_SWITCHER);
};
